import * as React from "react";
import Head from "next/head";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { PreviewBadge } from "@lululemon/ui-library";
import { Mbox } from "@lululemon/mwa-ab-testing/esm";
import { BottomScripts } from "@lululemon/mwa-common";

import Script from "next/script";
import MegaNav from "./mega-nav/mega-nav";
import StaticHead, {
  PriorityMetaTags,
} from "../../../ecom-site/src/components/static-head";

import { en_US } from "../translations";
import ConditionalRedirect from "./conditional-redirect/conditional-redirect";
import { publicConfig } from "../util/public-config";
import { isContentfulPreview } from "../lib/util";

import Footer from "./footer/footer";
import { getRegionalizedTitleTag } from "../util/locale-utils";
import CdpSeoDataServiceIndicator from "./cdp-seo-data-service-indicator";
import RegionalBannerWrapper from "./regional-banner-wrapper/regional-banner-wrapper";
import { useHeaderFlags } from "@lululemon/mwa-header-flags";

const PRIndicator = dynamic(() =>
  import("@lululemon/ufs-shared").then((module) => module.PRIndicator)
);

const { seo } = en_US.home;

export default function Layout({ children, locale }) {
  const router = useRouter();
  const { transPerfectHeader } = useHeaderFlags();
  const previewToken = publicConfig?.contentful?.previewToken;
  const isPreview = isContentfulPreview(router.query, previewToken);
  const regionalizedTitle = getRegionalizedTitleTag(router.locale, seo.title);
  return (
    <div id="app" data-testid="layout-root">
      <Head>
        <PriorityMetaTags />
        <title>{regionalizedTitle}</title>
        <meta name="robots" content="index, follow, noodp, noydir" />
        <StaticHead />
      </Head>
      <Mbox name="redirector-mbox">
        <ConditionalRedirect />
      </Mbox>
      <Mbox name="membership-city" />
      <CdpSeoDataServiceIndicator />
      {publicConfig.prIndicator ? (
        <PRIndicator prNumber={publicConfig.prIndicator} />
      ) : null}
      <MegaNav />
      <main id="main-content">{children}</main>
      <Footer />
      <BottomScripts listen="PEPS" />
      {isPreview && <PreviewBadge data-testid="preview-badge" />}
      <Script
        src={publicConfig.dtmSrc}
        strategy="afterInteractive"
        onLoad={() =>
          window.dispatchEvent(new CustomEvent("launchScriptLoaded"))
        }
        onReady={() =>
          window.dispatchEvent(new CustomEvent("launchScriptReady"))
        }
        onError={() =>
          window.dispatchEvent(new CustomEvent("launchScriptLoadError"))
        }
      />
      {!transPerfectHeader && <RegionalBannerWrapper />}
    </div>
  );
}
